/** ======================================
 * Helpers que manipulam arquivos de Texto
 * ======================================= */
/**
 * Cria um arquivo a partir de uma string
 *
 * @param {String} data - Conteúdo do arquivo
 * @param {String} name - Nome do arquivo
 * @param {String} dataType - Mime type do arquivo
 */

export const downloadFile = (
  data,
  name = 'download.txt',
  dataType = 'data:text/plain'
) => {
  const element = document.createElement('a')
  element.setAttribute(
    'href',
    `data:${dataType};charset=utf-8,${encodeURIComponent(data)}`
  )
  element.setAttribute('download', name)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}
